module.exports = __webpack_public_path__ + "static/media/confusion.a41a45a9.png";